import { classNames, extend } from '@dimjs/utils';
import { FC, ReactNode } from 'react';
import { Button, ButtonProps } from '../button';
import { Grid, GridItem, GridProps } from '../grid';
import { Modal, ModalProps } from '../modal';
import './style.less';

export type ModalConfirmProps = ModalProps & {
  children: string | JSX.Element;
  cancelText?: string | JSX.Element;
  okText?: string | JSX.Element;
  onCancel?: () => void | Promise<void>;
  onOK?: () => void | Promise<void>;
  reverse?: boolean;
  gridGap?: GridProps['gap'];
  okButtonProps?: Omit<ButtonProps, 'onClick' | 'stopPropagation'>;
  cancelButtonProps?: Omit<ButtonProps, 'onClick' | 'stopPropagation'>;
};

export const ModalConfirm: FC<ModalConfirmProps> = (props) => {
  const cancelButtonProps = extend({ size: 'large', fill: 'none', type: 'default' }, props.cancelButtonProps);
  const okButtonProps = extend({ size: 'large', fill: 'none', type: 'primary' }, props.okButtonProps);

  const btns = [
    <Button
      {...cancelButtonProps}
      className={classNames('v-modal-confirm-cancel', cancelButtonProps?.className)}
      onClick={props.onCancel || props.onClose}
      key="0"
    >
      {props.cancelText}
    </Button>,
    <Button {...okButtonProps} onClick={props.onOK || props.onClose} key="1">
      {props.okText}
    </Button>,
  ] as ReactNode[];

  const btnsList = props.reverse ? btns.reverse() : btns;
  return (
    <Modal closeByMask={false} {...props} className={classNames('v-modal-confirm', props.className)}>
      <div className="v-modal-confirm-content">{props.children}</div>
      <Grid columns={2} gap={props.gridGap} className="v-modal-confirm-operate">
        {btnsList.map((item, index) => {
          return <GridItem key={index}>{item}</GridItem>;
        })}
      </Grid>
    </Modal>
  );
};

ModalConfirm.defaultProps = {
  cancelText: '取消',
  okText: '确定',
  gridGap: 0,
};
